package com.swetdot.swetgram.data.auth

/** Tab-scoped storage avoids sharing a rotating refresh token between independent tabs. */
actual class SessionStore : SessionStorage {
    private var memory: StoredSession? = null
    private val storage: dynamic get() = js("window.sessionStorage")
    private val key = "swetgram.session.v1"

    actual override fun load(): StoredSession? {
        val raw = runCatching { storage.getItem(key) as String? }.getOrNull() ?: return memory
        return runCatching { decodeStoredSession(raw) }.getOrElse {
            clear()
            null
        }
    }

    actual override fun save(session: StoredSession) {
        memory = session
        // Private browsing / denied storage still permits an in-memory signed-in session.
        runCatching { storage.setItem(key, session.encodeForStorage()) }
    }

    actual override fun clear() {
        memory = null
        runCatching { storage.removeItem(key) }
    }
}
